<template>
  <Sidebar>
    <ul class="nav flex-column">
      <li
        v-for="route in routes"
        :key="route.name"

        class="nav-item border-bottom border-white border-2 p-4"
      >
        <router-link
          :to="route.to"
          class="nav-link deepify-dark-text d-inline-block"
        >
          {{ route.name }}
        </router-link>
      </li>
    </ul>
  </Sidebar>
</template>

<script>
import Sidebar from '@/components/core/Sidebar';

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      routes: [
        {
          name: 'HOME',
          to: '/',
        },
      ],
    };
  },
};
</script>

<style scoped>
.nav-link:hover {
  color: #444444;
  opacity: 0.5;
  transition: 0.3s ease all;
}

.router-link-active {
  font-weight: bold;
}
</style>
